import { useAuthStore } from '@/stores/auth'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import adminRoutes from '../modules/admin/routes'
import recruiterRoutes from '../modules/recruiter/routes'
import authRoutes from '../modules/auth/routes'
import agencyRoutes from '../modules/agency/routes'
import businessRoutes from '../modules/business/routes'

const routes = [
  ...recruiterRoutes,
  ...adminRoutes,
  ...authRoutes,
  ...agencyRoutes,
  ...businessRoutes,

  // Temp dev routes
  {
    path: '/dev-form',
    name: 'DevForm',
    component: () => import('@/components/form/DevForm.vue'),
    meta: {
      public: true,
    },
  },

  // Public routes
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/fee-calculator',
    name: 'FeeCalculator',
    component: () => import('@/components/FeeCalculatorPage.vue'),
  },
  {
    path: '/messages',
    name: 'Messages',
    component: () => import('@/components/chat/Messages.vue'),
  },
  {
    path: '/discover',
    name: 'Discover',
    component: () => import('@/views/Discover.vue'),
    meta: {
      public: true,
    },
  },

  // Catch all 404
  {
    path: '*',
    name: '404',
    component: () => import('@/views/404.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const auth = useAuthStore()
  // Adds openCalculator checker to open feeCalc componenet automatically,
  // when recruiters or Agencies got to app.relancer.com/#calculator url
  if (!auth.user && window.location.hash === '#calculator') {
    window.sessionStorage.openCalculator = true
  }
  // Save route to sessionStorage
  // Only if user is not already logged in,
  // Redirection doesn't exist already
  // and it's not one of the public paths
  if (
    !auth.user &&
    !window.sessionStorage.redirectTo &&
    !(to.meta.public || to.name === 'Home')
  ) {
    window.sessionStorage.redirectTo = to.fullPath
  }

  // Check if user is signed in
  if (auth.user) {
    // Redirect public routes back to "home"
    if (to.meta.public) {
      // In special cases, allow logged in users to see public route
      if (to.name === 'Discover') {
        const url = new URL('https://app.relancer.com/recruiter-search')
        if (to.query.country) {
          url.searchParams.append('country', to.query.country)
        }
        if (to.query.role) {
          url.searchParams.append('role', to.query.role)
        }
        return next(`${url.pathname}${url.search}`)
      }
      return next('/')
    }
    if (to.path === '/') {
      if (auth.business) {
        return next(`/business/${auth.business.id}/projects`)
      } else if (auth.agency) {
        return next(`/agency/${auth.agency.id}/matches`)
      } else {
        return next(`/recruiter/${auth.recruiter.id}/matches`)
      }
    }
    return next()
  }
  // Otherwise allow only login
  if (to.meta.public) {
    return next()
  } else {
    return next('/login')
  }
})

export default router
